import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_ALL_PASARTERNAK, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_PASARTERNAK = 'GET_LIST_PASARTERNAK';

export const getPasarTernak = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_PASARTERNAK);

    axios({
      method: 'get',
      url: GET_ALL_PASARTERNAK,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_PASARTERNAK, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_PASARTERNAK,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_PASARTERNAK, 'error');
        alert(error);
      });
  };
};
